import React from 'react'
import ReactDOM from 'react-dom'
import TagManager from 'react-gtm-module'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material'
import theme from 'lib/theme'
import { BrowserRouter } from 'react-router-dom'
import 'lib/i18'
import RouteLinks from 'routes/RouteLinks'
import AuthProvider from 'providers/AuthProvider'
import { AuthProviderWrapper } from 'providers/AuthProviderWrapper'
import LocaleProvider from 'providers/LocaleProvider'
import AlertProvider from 'providers/AlertProvider'
import PlacesProvider from 'providers/PlacesProvider'
import { NotificationProvider } from 'providers/NotificationProvider'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import reportWebVitals from './reportWebVitals'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

const tagManagerArgs = {
  gtmId: window.appConfig.GTM_ID || '',
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProviderWrapper>
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <LocaleProvider>
                <AlertProvider>
                  <NotificationProvider>
                    <PlacesProvider>
                      <RouteLinks />
                    </PlacesProvider>
                  </NotificationProvider>
                </AlertProvider>
              </LocaleProvider>
              {process.env.NODE_ENV === 'development' && (
                <ReactQueryDevtools initialIsOpen={false} />
              )}
            </QueryClientProvider>
          </AuthProvider>
        </AuthProviderWrapper>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
